import { jsx as m } from "react/jsx-runtime";
import { c as a } from "../../index-Cu0xwYjD.js";
import { StackCssClass as s } from "./Stack.types.js";
import { getResponsiveLayoutModifiers as i } from "../../utils/helpers.responsive.js";
import { GutterSize as p } from "../../utils/enums.js";
const c = ({
  children: o,
  className: t,
  gutter: r = "none",
  ...e
}) => /* @__PURE__ */ m(
  "div",
  {
    className: a(
      t,
      s.Base,
      i(s.Gutter, r, "none")
    ),
    ...e,
    children: o
  }
);
c.Gutter = p;
export {
  c as IressStack
};
